// extracted by mini-css-extract-plugin
export default {"root":"IconChildFriendly_root__3zkcY"};